module.exports = function drawSwirl(ctx) {
  ctx.save();
  ctx.fillStyle = '#333';
  ctx.beginPath();
  ctx.moveTo(277.353, 2.93555);
  ctx.bezierCurveTo(179.837, 73.7852, 158.22, 210.271, 229.067, 307.787);
  ctx.bezierCurveTo(275.989, 372.367, 351.696, 403.66, 425.806, 396.854);
  ctx.bezierCurveTo(328.591, 464.24, 194.86, 441.895, 124.981, 345.713);
  ctx.bezierCurveTo(54.1299, 248.197, 75.7471, 111.709, 173.263, 40.8594);
  ctx.bezierCurveTo(206.2, 16.9316, 243.579, 3.55078, 281.376, 0.078125);
  ctx.lineTo(279.462, 1.41992);
  ctx.bezierCurveTo(278.755, 1.91992, 278.052, 2.42578, 277.353, 2.93555);
  ctx.closePath();
  ctx.moveTo(450.388, 178.842);
  ctx.bezierCurveTo(521.235, 81.3262, 657.724, 59.709, 755.239, 130.559);
  ctx.lineTo(756.817, 131.717);
  ctx.lineTo(757.821, 132.461);
  ctx.lineTo(759.2, 133.506);
  ctx.bezierCurveTo(744.22, 98.6309, 719.942, 67.2129, 687.005, 43.2832);
  ctx.bezierCurveTo(589.489, -27.5664, 453.005, -5.94922, 382.153, 91.5664);
  ctx.bezierCurveTo(312.274, 187.748, 332.349, 321.84, 426.474, 393.473);
  ctx.bezierCurveTo(397.099, 325.092, 403.466, 243.422, 450.388, 178.842);
  ctx.closePath();
  ctx.moveTo(781.825, 625.113);
  ctx.bezierCurveTo(819.075, 510.477, 756.337, 387.35, 641.7, 350.104);
  ctx.bezierCurveTo(565.782, 325.436, 486.142, 344.619, 430.185, 393.686);
  ctx.bezierCurveTo(469.224, 282.029, 590.552, 221.502, 703.618, 258.24);
  ctx.bezierCurveTo(818.255, 295.486, 880.993, 418.613, 843.743, 533.25);
  ctx.bezierCurveTo(831.165, 571.969, 808.786, 604.768, 780.247, 629.793);
  ctx.lineTo(780.915, 627.857);
  ctx.lineTo(781.47, 626.189);
  ctx.lineTo(781.825, 625.113);
  ctx.closePath();
  ctx.moveTo(319.759, 802.969);
  ctx.bezierCurveTo(440.294, 802.969, 538.009, 705.254, 538.009, 584.719);
  ctx.bezierCurveTo(538.009, 504.895, 495.153, 435.078, 431.196, 397.023);
  ctx.bezierCurveTo(549.454, 399.648, 644.509, 496.332, 644.509, 615.219);
  ctx.bezierCurveTo(644.509, 735.754, 546.794, 833.469, 426.259, 833.469);
  ctx.bezierCurveTo(385.548, 833.469, 347.438, 822.322, 314.821, 802.914);
  ctx.bezierCurveTo(316.462, 802.951, 318.11, 802.969, 319.759, 802.969);
  ctx.closePath();
  ctx.moveTo(282.548, 558.994);
  ctx.bezierCurveTo(167.911, 596.242, 44.7861, 533.506, 7.53612, 418.869);
  ctx.bezierCurveTo(7.02831, 417.299, 6.53612, 415.729, 6.06346, 414.156);
  ctx.bezierCurveTo(-2.31544, 451.176, -1.13966, 490.863, 11.4385, 529.582);
  ctx.bezierCurveTo(48.6885, 644.219, 171.813, 706.955, 286.45, 669.707);
  ctx.bezierCurveTo(399.517, 632.971, 462.095, 512.689, 428.048, 399.41);
  ctx.bezierCurveTo(411.622, 471.996, 358.466, 534.328, 282.548, 558.994);
  ctx.closePath();
  ctx.fill();
  ctx.restore();
};
